<div class="row">
    <div class="offset-md-1 col-md-10">
        <div *ngIf="showDateRange" class="form-group row">
            <div class="col-md-6">
                <label>Start Date:</label>
                <input type="text" class="w-100 form-control" bsDatepicker [formControl]="startDate">
            </div>
            <div class="col-md-6">
                <label>End Date:</label>
                <input type="text" class="w-100 form-control" bsDatepicker [formControl]="endDate">
            </div>
        </div>
        <div *ngIf="showMonthSelection" class="form-group row">
            <div class="col-md-6">
                <label>Month/Year:</label>
                <input type="month" class="form-control w-100" [formControl]="monthYear" (click)="openCalendar($event)">
            </div>
        </div>
        <div *ngIf="showMonthRangeSelection" class="form-group row">
            <div class="col-md-6">
                <label>Start Month/Year:</label>
                <input type="month" class="form-control w-100" [formControl]="startMonthYear" (click)="openCalendar($event)">
            </div>
            <div class="col-md-6">
                <label>End Month/Year:</label>
                <input type="month" class="form-control w-100" [formControl]="endMonthYear" (click)="openCalendar($event)">
            </div>
        </div>
        <div class="form-group row">
            <div *ngIf="showStatuses" class="col-md-6">
            <label>Statuses:</label>
                <select keepingCurrentStatus [formControl]="statuses" class="form-control w-100">
                </select>
            </div>
            <div *ngIf="showAgencies" class="col-md-6">
                <label>Agency:</label>
                <input #agency type="text" class="form-control w-100" (click)="agencyListModal.open()" value='All Agencies'>
                <agency-box (onAgencySelected)="agencyId.setValue($event && $event.id); agency.value = $event && $event.agencyName || 'All Agencies'"></agency-box>
            </div>
        </div>

        <div *ngIf="showExportDescription" class="form-group row">
            <div class="col-md-10">
                <label>Export Description:</label>
                <select [formControl]="exportDescription" class="form-control w-100">
                    <option value="new">[new]</option>
                    <option *ngFor="let item of approvedEnrollmentHistory"
                            [value]="item.downloadTimestamp">{{ item.downloadTimestamp | moment:dateFormat}} ... {{ item.count }}
                        Approved Enrollment Record(s)
                    </option>
                </select>
            </div>
        </div>
        <ng-content></ng-content>
    </div>
</div>
